/* global Sys, Core, Language, Services, Resources */
Sys.ns("Core");

/**
 * The Reality Check controller.
 *
 * @class Core.RealityCheckController
 * @extends Core.Controller
 */
Core.RealityCheckController = {

    /** @inheritdoc */
    constructor: function() {
        Core.RealityCheckController.superclass.constructor.apply(this, arguments);
    },

    /** @inheritdoc */
    setupEvents: function() {
        this.on({
            "notify:stateHandler.enteringRealityCheckState": this.doRealityCheck,

            "notify:responseParser.rcInfoParsed": this.handleInfoResponse,
            "notify:responseParser.rcInfoReset": this.handleResetResponse,
            "notify:responseParser.responseParsed": this.onServerResponse,

            // Freerounds re-initialization handling
            "notify:responseParser.gameConfigurationParsed": this.onFreeRoundsEnded
        });
    },

    /**
     * Store the server response.
     *
     * @private
     * @param {Object} serverResponse The parsed server response.
     * @returns {void}
     */
    onServerResponse: function(serverResponse) {
        this.model.processServerResponse(serverResponse);
    },

    /**
     * Send a request to server manager.
     *
     * @param {string} action The action to be requested from server manager.
     * @param {string} parseCompleteEvent The event to be fired by response parser module when parsing is complete.
     * @returns {void}
     */
    sendServerAction: function(action, parseCompleteEvent) {
        this.model.setState("requestPending");
        this.fireEvent("request:serverManager.sendAction", action, parseCompleteEvent);
    },

    /**
     * Handle the response after a reset request.
     *
     * @param {Object} response The parsed server response.
     * @returns {void}
     */
    handleResetResponse: function(response) {
        this.model.storeData("msUntilTimeout", response.rc.msuntiltimeout);
        this.model.storeData("lastCheckTime", Date.now());
        this.complete(response.clientaction);
    },

    /**
     * Handle the response after a reality check request.
     *
     * @param {Object} response The parsed server response.
     * @returns {void}
     */
    handleInfoResponse: function(response) {
        var me = this,
            rcParams = response.rc,
            string,
            playerResult,
            duration,
            actionToBeDone = response.clientaction;

        if (Sys.isDefined(rcParams) && rcParams.msuntiltimeout <= 0) {
            duration = Math.round(rcParams.duration / 60 / 60 / 10) / 100;

            if (rcParams.totalwin >= 0) {
                playerResult = rcParams.totalwin;
                string = Language.Keys.rc_checkPlayingWon;
            }
            else {
                playerResult = Sys.utils.toInt(-rcParams.totalwin);
                string = Language.Keys.rc_checkPlayingLost;
            }

            me.requestDialog(Services.languageManager.getText(string, [duration, Services.moneyManager.formatMoneyCurrencySign(playerResult)]), actionToBeDone);
            me.model.setState("dialogOpen");
        }
        else {
            me.handleResetResponse(response);
        }
    },

    /**
     * Request a dialog from the dialog manager.
     *
     * @param {string} message The message to be displayed.
     * @param {action} action The action to be done after dialog is closed.
     * @returns {void}
     */
    requestDialog: function(message, action) {
        var dialogConfig = this.model.getDialog(message, this, action);

        Services.dialog.show(dialogConfig);
    },

    /**
     * Fire event when reality check sequence has been completed.
     *
     * @param {string} action The action to be completed.
     * @returns {void}
     */
    complete: function(action) {
        this.fireEvent("notify:realityCheck:completed", action);
    },

    /**
     * When entering idle state do a reality check if supported.
     *
     * @returns {void}
     */
    doRealityCheck: function() {
        this.sendServerAction("rcinfo", "notify:responseParser.rcInfoParsed");
    },

    /**
     * When Free Rounds end and new game configuration has been received from server.
     *
     * @returns {void}
     */
    onFreeRoundsEnded: function() {
        this.model.processInitData(Resources.readData("gameServerInitResponse"));
    }
};

Core.RealityCheckController = Sys.extend(Core.Controller, Core.RealityCheckController, "Core.RealityCheckController");
